export default {
  // newly created getters
  getSelectedProduct(state) {
    return state.selectedProduct;
  },
  getProductSvg(state) {
    if (state.productSvg.length == 0) { return []; }
    return state.productSvg;
  },
  getSVGCategories(state) {
    if (state.SVGCategories.length == 0) { return []; }
    return state.SVGCategories;
  },
  getFavouriteSizes(state) {
    if (state.favouriteSizes.length === 0) { return []; }
    return state.favouriteSizes;
  },
  getCrop(state) {
    return state.crop;
  },
  getAllNewPmsColors(state) {
    return state.AllNewPmsColors;
  },
  getSelection(state) {
    return state.selection;
  },
  getCMYKColor(state) {
    return state.CMYKColor;
  },
  getProductColor(state) {
    return state.productColor;
  },
  getAllYourColors(state) {
    return state.yourColor;
  },
  getSelectedPageAllObjects(state) {
    // console.log(state)
    // return state.selectedProduct.pages[state.selectedPage];
    return state.selectedProduct.pages[state.selectedPage].objectList;
  },
  getSelectedObjectList(state) {
    const objectList = [];
    state.selection.index.forEach((index) => {
      objectList.push(state.selectedProduct.pages[state.selectedPage].objectList[index]);
    });
    return objectList;
  },
  getLeftPanelToShow(state) {
    return state.leftPanelToShow;
  },
  getIsUnitInInch(state) {
    return state.isUnitInInch;
  },
  getIsAddNewImageModal: state => state.isAddNewImageModal,
  // newly created getters ended

  getBaseImage(state) {
    return state.baseImage;
  },
  // previously used getters by team
  getproductfontarray:        state => state.productfontarray,
  getRedirectUrl:             state => state.redirectUrl,
  isImageModel:               state => state.isimageopen,
  isShapeModel:               state => state.isShapeModelOpen,
  getColorPickerValue:        state => state.colorpicker.color,
  getIsOpen:                  state => state.colorpicker.isopen,
  getIsSavedAndClosed:        state => state.isSavedAndClosed,
  getSaveApiMethod:           state => state.SaveApiMethod, // isSubmitted
  getUndoRedoArrayListLength: state => state.undoRedoArrayListLength,
  getBankId:                  state => state.bankId,
  getUserId:                  state => state.userId,
  getAddressBoxes:            state => state.addressBoxes,
  getFdicLogos:               state => state.fdicLogos,
  getNcuaLogos:               state => state.ncuaLogos,
  getHousingLogos:            state => state.housingLogos,
  getDefaultCropMarks:        state => state.defaultCropMarks,
  getOrderItemId:             state => state.orderItemId,
  getBaseUrl:                 state => state.BaseUrl,
  getBMCInstance:             state => state.BMCInstance,
  getBankPMSColorList:        state => state.bankPMSColor.bankPmsColorList,
  getNSHandle:                state => state.boundingBoxHandle.ns,
  getEWHandle:                state => state.boundingBoxHandle.ew,
  getZoomLevel:               state => state.zoomLevel,
  getScrollPosition:          state => state.canvasScrollPosition,
  getHorizontalGuides:        state => state.horizontalGuides,
  getVerticalGuides:          state => state.verticalGuides,
  getSnappingEnabled:         state => state.snappingEnabled,
  getDisplayQRCodeModal:      state => state.displayQRCodeModal,
  getSVGCategoryFilter:       state => state.svgCategoryFilter,
  getDisplayPreviewModal:     state => state.displayPreviewModal,
  getDisplayAddVideoModal:    state => state.displayAddVideoModal,
  getDisplayAddAudioModal:    state => state.displayAddAudioModal,
  getIsLoaderVisible:         state => state.isLoaderVisible,
  getPreviewClicked:          state => state.previewClicked,
  getDisplayHelpText:         state => state.displayHelpText,

  getRGBAllNewPmsColors: (state, getters) => (cmykColor) => {
    let rgbColor          = cmykColor;
    const AllNewPmsColors = getters.getAllNewPmsColors;
    for (let colorListIndex = 0; colorListIndex < AllNewPmsColors.length; colorListIndex += 1) {
      if (AllNewPmsColors[colorListIndex].DisplayColorTextCMYK == cmykColor) {
        rgbColor = AllNewPmsColors[colorListIndex].DisplayColorTextRGB;
      }
    }
    return rgbColor;
  },
  getRGBFromBankPMSColorListByCMYK: (state, getters) => (cmykColor) => {
    let rgbColor               = null;
    const { bankPmsColorList } = state.bankPMSColor;
    for (let colorListIndex = 0; colorListIndex < bankPmsColorList.length; colorListIndex += 1) {
      if (bankPmsColorList[colorListIndex].colorCMYK == cmykColor) {
        rgbColor = bankPmsColorList[colorListIndex].colorRGB;
        break;
      }
    }
    if (!rgbColor) {
      rgbColor = getters.getRGBValueFromCMYK(cmykColor);
    }
    return rgbColor;
  },

  getRGBValueFromCMYK: state => (cmyk) => {
    if (typeof cmyk === 'undefined' || cmyk == null || cmyk == '') { return '#000000'; }
    const cmykArr = cmyk.replace('cmyk(', '').replace(')', '').replace(/%/g, '').split(' ');
    let r,
      g,
      b;
    let c         = parseInt(cmykArr[0]) / 100,
      m = parseInt(cmykArr[1]) / 100,
      y = parseInt(cmykArr[2]) / 100,
      k = parseInt(cmykArr[3]) / 100;
    r             = Math.round(255 - ((Math.min(1, c * (1 - k) + k)) * 255));
    g             = Math.round(255 - ((Math.min(1, m * (1 - k) + k)) * 255));
    b             = Math.round(255 - ((Math.min(1, y * (1 - k) + k)) * 255));
    return `rgb(${r},${g},${b})`;
  },
  getCopiedObjects(state) {
    return state.copiedObjects;
  },
  getIsVideoModel(state) {
    return state.isVideoModel;
  },
  getSubmittedAs(state) {
    return state.submittedAs;
  },
  getIsBgRemoverOpen(state) {
    return state.isOpenBgRemoverModal;
  },
  getBgRemoverImagesList(state) {
    return state.bgRemoverImagesList;
  },
  getTimeLinePercentage(state) {
    return state.timeLinePercentage;
  }
};
